import "./front-page.css";

export default function FrontPage() {
  return (
    <div className="FrontPage">
      <div id="front-page">
        <div className="front-page-wrapper">
          <div className="front-page-content">
            <h1 className="front-page-heading">
              <span className="accent">VHB</span> Gorušica
              <br />
              <span className="accent">V</span>erein für{" "}
              <span className="accent">H</span>ilfe in{" "}
              <span className="accent">B</span>osnien
            </h1>
            <div className="front-page-divider"></div>
          </div>
          <div className="scroll-indicator">
            <div className="scroll-arrow"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
